import React from 'react';
import { Chip } from '@mui/material';
import AppIcon from './AppIcon';

const priorityConfig: Record<string, { label: string; color: string; bg: string }> = {
  high: { label: 'High', color: '#C26A6A', bg: 'rgba(194,106,106,0.15)' },
  medium: { label: 'Medium', color: '#D4A84E', bg: 'rgba(212,168,78,0.15)' },
  low: { label: 'Low', color: '#7A7269', bg: '#E4DED8' },
};

interface PriorityChipProps {
  priority: string;
}

const PriorityChip: React.FC<PriorityChipProps> = ({ priority }) => {
  const config = priorityConfig[priority] || priorityConfig.medium;
  return (
    <Chip
      icon={<AppIcon name="flag" sx={{ fontSize: 14, color: `${config.color} !important` }} />}
      label={config.label}
      size="small"
      sx={{ color: config.color, backgroundColor: config.bg, fontWeight: 500 }}
    />
  );
};

export default PriorityChip;
